import { cva, type VariantProps } from "class-variance-authority";
import { Separator as SeparatorPrimitive } from "radix-ui";
import type * as React from "react";

import { cn } from "../utils/index";

const separatorVariants = cva(
  "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
  {
    variants: {
      // Not upstream: runs through the container's side padding, set as --separator-bleed.
      bleed: {
        true: "data-horizontal:mx-[calc(var(--separator-bleed,0px)*-1)] data-horizontal:w-[calc(100%+var(--separator-bleed,0px)*2)]",
        false: "",
      },
    },
    defaultVariants: { bleed: false },
  },
);

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  bleed,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root> &
  VariantProps<typeof separatorVariants>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(separatorVariants({ bleed }), className)}
      {...props}
    />
  );
}

export { Separator };
